import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/shared/components/ui/button/button';
import {
  Modal,
  ModalContainer,
} from '@/shared/components/ui/modal-controller/modal-controller.styled';
import { useTenant } from '@/shared/features/auth/context/tenant-context';

export const SwitchTenantInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openTenantSwitchInfo } = useTenant();

  const handleRefresh = () => {
    navigate('/', { replace: true });
    setTimeout(() => window.location.reload(), 0);
  };

  return (
    <Modal open={openTenantSwitchInfo} disableEscapeKeyDown>
      <ModalContainer width="28rem">
        <Stack gap="2rem">
          <Stack gap="1.25rem">
            <Typography variant="h5">
              {t('onboarding:tenant_switch_title')}
            </Typography>
            <Typography variant="p5">
              {t('onboarding:tenant_switch_description')}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="flex-end"
            gap="0.75rem"
            width="100%"
          >
            <Button onClick={handleRefresh} size="large">
              {t('common:refresh')}
            </Button>
          </Stack>
        </Stack>
      </ModalContainer>
    </Modal>
  );
};
